import evonikLogo from '../media/evoniklogo.gif'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck, faCaretDown, faBars, faSignOut, faBook } from '@fortawesome/pro-solid-svg-icons'
import { Dispatch } from './architecture/frontend/index'
import Popover from 'react-popover'

const Header = (props) => {
  const companyName = props.company?.name
  const companyLogo = props.company?.logo
  const sidebarWidth = props._sidebarWidth
  const PopoverListItem = (props) => {
    const onClick = props.onClick
    return (
      <div className={'flex justify-between items-center pv1 mv1 b--light-gray pointer ' + (props._noBorderBottom ? '' : ' bb ') } 
        onClick={e => { 
          onClick(e)
          Dispatch.nextState('popover.company', false)
          Dispatch.nextState('popover.user', false)
        }}>
        <div className='flex'>
          <div className=''><FontAwesomeIcon className='pl2 f6 evonik-purple' icon={props._icon} /></div>
          <div className='pl2 evonik-purple fw5'>{props._title}</div>
        </div>
        {props._count && 
          <div className=' ph2 bg-evonik-purple br3 white f7 fw6' style={{paddingTop:3, paddingBottom:2}}>
            {props._count}
          </div>
        }
      </div>
    )
  }

  const companyBody = [
    <div className='pa3 bg-white br bl bb br2 b--light-gray shadow-4 avenir f6' style={{width:210}}>
      <PopoverListItem _title='Dashboard' _icon={faTruck} _noBorderBottom={true} onClick={e => Dispatch.nextAction('view', {type: 'home'})} {...props}/>
      <div className='pt1'></div>
      <PopoverListItem _title='Locations' _icon={faBars} {...props} onClick={e => Dispatch.nextAction('view', {type: 'table', details: {table: 'locations', data: 'locations'} })}/>
      <PopoverListItem _title='Customers' _icon={faBars} {...props} onClick={e => Dispatch.nextAction('view', {type: 'table', details: {table: 'customers', data: 'customer'} })}/>
      <PopoverListItem _title='Referee Labs' _icon={faBars} {...props} onClick={e => Dispatch.nextAction('view', {type: 'table', details: {table: 'labs', data: 'labs'} })}/>
      <PopoverListItem _title='Ingredients' _icon={faBars} {...props} onClick={e => Dispatch.nextAction('view', {type: 'table', details: {table: 'ingredients', data: 'ingredients'} })}/>
      <PopoverListItem _title='Shipment Types' _icon={faBars} _noBorderBottom={true} {...props} onClick={e => Dispatch.nextAction('view', {type: 'table', details: {table: 'shipmentTypes', data: 'shipmentTypes'} })}/>
      {/* <div className='pt1'></div>
      <PopoverListItem _title='Lab Settings' _icon={faCog} _noBorderBottom={true} {...props}/> */}
    </div>
  ]
  const userBody = [
    <div className='pa3 bg-white br bl bb br2 b--light-gray shadow-4 avenir f6' style={{width:205}}>
      {/* <PopoverListItem _title='Account Settings' _icon={faUser} _noBorderBottom={true} onClick={e => Dispatch.nextAction('view', {type: 'accountSettings' })} {...props}/> */}
      <PopoverListItem _title='Terms of Use' _icon={faBook} _noBorderBottom={true} onClick={e => Dispatch.nextAction('view', {type: 'tos' })} {...props}/>
      <div className='pt1'></div>
      <PopoverListItem _title='Sign Out' onClick={e => Dispatch.nextAction('signOut')} _icon={faSignOut} _noBorderBottom={true} {...props}/>
    </div>
  ]

  return (
    <div className='flex justify-between'>
        <div className='flex'>
          <div className='w-100 bg-white' style={{height:56.5, width: sidebarWidth}}>
            <div className='relative pointer' style={{top:7, left: 11, width:154, height:40}}
              onClick={e => Dispatch.nextAction('view', {type: 'home'})}
            >
              <img src={evonikLogo} alt='loading'/>
            </div>
          </div>
          <Popover className='' style={{zIndex:10000}} isOpen={props.popover?.company ?? false} body={companyBody} place='below' tipSize={10} onOuterAction={e => Dispatch.nextState('popover.company', false)}>
            <div className='pl4 flex items-center pointer'
              onClick={e => Dispatch.nextState('popover.company', !props.popover?.company ?? false)}
              >
              {companyLogo ? <img src={companyLogo} style={{height:33}} alt='company logo' /> : <div className='bg-light-gray br2 w3 h2'></div> }
              <div className='pl3 evonik-purple fw5 f5'>{companyName}</div>
              <FontAwesomeIcon className='pl2 f6 evonik-purple' icon={faCaretDown} />
            </div>
          </Popover>
        </div>
        <Popover className='' style={{zIndex:10000}} isOpen={props.popover?.user ?? false} body={userBody} place='below' tipSize={10} onOuterAction={e => Dispatch.nextState('popover.user', false)}>
          <div className='pr4 flex items-center pointer'
              onClick={e => Dispatch.nextState('popover.user', !props.popover?.user ?? false)}
            >
              <div className='fw5 evonik-purple'>{props.user?.email}</div>
              <FontAwesomeIcon className='pl2 f6 evonik-purple' icon={faCaretDown} />
          </div>
        </Popover>
      </div>
  )
}

export default Header